const personalInfo = {
  name: "Furkan Öztürk",
  title: "Computer Science Student",
  email: "fu.ozturk25@gmail.com",
  location: "Venlo, The Netherlands",
  bio: "Hi, my name is Furkan Öztürk. I'm a passionate software developer with a strong foundation in PHP and Python. My journey in tech began at Gilde ICT College in Roermond, where I gained hands-on experience by working on real-world client-based projects instead of following a traditional classroom approach. This method helped me develop practical problem-solving skills, teamwork abilities, and an understanding of how to build software solutions that meet real business needs.",
  socialLinks: {
    github: "https://github.com/Turkie25"
  },
  resumePath: "/assets/resume/CV_Furkan-Öztürk.pdf"
};

export default personalInfo;